<form *ngIf="rfqForm" [formGroup]="rfqForm" (ngSubmit)="onSubmit()" class="rfq-details-form">
  <div class="form-row-container">
    <div class="form-col">
      <label [ngClass]="{'label-invalid': (f['rfqName'].touched || submitted) && f['rfqName'].invalid}">
        RFQ Name<sup class="required-star">*</sup>
      </label>
      <input formControlName="rfqName" type="text" placeholder="Enter RFQ Name"
        [ngClass]="{'input-invalid': (f['rfqName'].touched || submitted) && f['rfqName'].invalid}" />
      <!-- <div class="error" *ngIf="(f['rfqName'].touched || submitted) && f['rfqName'].invalid">Required</div> -->

      <div class="form-row">
        <div class="form-col">
          <label [ngClass]="{'label-invalid': (f['fullName'].touched || submitted) && f['fullName'].invalid}">
            Full Name<sup class="required-star">*</sup>
          </label>
          <input formControlName="fullName" type="text" placeholder="First and Last"
            [ngClass]="{'input-invalid': (f['fullName'].touched || submitted) && f['fullName'].invalid}" />
          <!-- <div class="error" *ngIf="(f['fullName'].touched || submitted) && f['fullName'].errors?.['pattern']">
            Please enter a valid name
          </div> -->
        </div>
        <div class="form-col">
          <label [ngClass]="{'label-invalid': (f['companyName'].touched || submitted) && f['companyName'].invalid}">
            Company Name<sup class="required-star">*</sup>
          </label>
          <input formControlName="companyName" type="text" placeholder="Enter Company Name"
            [ngClass]="{'input-invalid': (f['companyName'].touched || submitted) && f['companyName'].invalid}" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-col">
          <label [ngClass]="{'label-invalid': (f['email'].touched || submitted) && f['email'].invalid}">
            Email<sup class="required-star">*</sup>
          </label>
          <input formControlName="email" type="email" placeholder="Enter Email Address"
            [ngClass]="{'input-invalid': (f['email'].touched || submitted) && f['email'].invalid}" />
          <!-- <div class="error" *ngIf="(f['email'].touched || submitted) && f['email'].errors?.['email']">
            Please enter a valid email address
          </div> -->
        </div>
        <div class="form-col">
          <label [ngClass]="{'label-invalid': (f['phoneNo'].touched || submitted) && f['phoneNo'].invalid}">
            Phone<sup class="required-star">*</sup>
          </label>
          <input formControlName="phoneNo" type="tel" placeholder="Enter Phone Number" maxlength="14"
            phoneFormat
            [ngClass]="{'input-invalid': (f['phoneNo'].touched || submitted) && f['phoneNo'].invalid}" />
          <!-- <div class="error" *ngIf="(f['phoneNo'].touched || submitted) && f['phoneNo'].errors?.['pattern']">
            Please enter a valid phone number
          </div> -->
        </div>
      </div>

      <div class="form-row">
        <div class="form-col">
          <label [ngClass]="{'label-invalid': (f['quoteBy'].touched || submitted) && f['quoteBy'].invalid}">
            Quote By<sup class="required-star">*</sup>
          </label>
          <p-datepicker formControlName="quoteBy" [minDate]="minQuoteByDate" [showIcon]="true" dateFormat="mm/dd/yy"
            placeholder="MM/DD/YYYY" [ngClass]="{
              'input-invalid': (f['quoteBy'].touched || submitted) && f['quoteBy'].invalid
            }">
          </p-datepicker>
          <!-- <div class="error" *ngIf="(f['quoteBy'].touched || submitted) && f['quoteBy'].invalid">Required</div> -->
        </div>
        <div class="form-col">
          <label [ngClass]="{'label-invalid': (f['deliverBy'].touched || submitted) && f['deliverBy'].invalid}">
            Deliver By<sup class="required-star">*</sup>
          </label>
          <p-datepicker #calendar formControlName="deliverBy" [minDate]="minDeliverByDate"
            [disabled]="rfqForm.get('deliverBy')?.status === 'DISABLED'" [showIcon]="true" dateFormat="mm/dd/yy"
            placeholder="MM/DD/YYYY" [ngClass]="{
              'input-invalid': (f['deliverBy'].touched || submitted) && f['deliverBy'].invalid
            }">
          </p-datepicker>
          <!-- <div class="error" *ngIf="(f['deliverBy'].touched || submitted) && f['deliverBy'].invalid">Required</div> -->
        </div>
      </div>
      <div class="form-row">
        <div class="form-col">
          <label>Shipping Address<sup class="required-star">*</sup></label>
          <div class="mb-2">
            <input formControlName="address1" type="text" placeholder="Address line 1"
              [ngClass]="{'input-invalid': (f['address1'].touched || submitted) && f['address1'].invalid}" />
          </div>
          <!-- <div class="error" *ngIf="(f['address1'].touched || submitted) && f['address1'].invalid">Required</div> -->
          <input formControlName="address2" type="text" placeholder="Address line 2" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-col-item">
          <input class="custom-city-input" formControlName="city" type="text" placeholder="City"
            [ngClass]="{'input-invalid': (f['city'].touched || submitted) && f['city'].invalid}" />
          <!-- <div class="error" *ngIf="(f['city'].touched || submitted) && f['city'].invalid">Required</div> -->
        </div>
        <div class="form-col-item">
          <p-select formControlName="state" [options]="stateList" optionLabel="state" optionValue="stateId"
            placeholder="Select State" styleClass="w-full" class="custom-state-select state-select-box"
            [ngClass]="{'input-invalid': (f['state'].touched || submitted) && f['state'].invalid}">
          </p-select>
          <!-- <div class="error" *ngIf="(f['state'].touched || submitted) && f['state'].invalid">Required</div> -->
        </div>
        <div class="form-col-item">
          <input formControlName="zip" type="text" placeholder="Zip Code" [maxlength]="zipMaxLength"
            [ngClass]="{'input-invalid': (f['zip'].touched || submitted) && f['zip'].invalid}" />
          <div class="error" *ngIf="(f['zip'].touched || submitted) && f['zip'].invalid">
            <!-- <span *ngIf="f['zip'].errors && f['zip'].errors['required']">Required</span> -->
            <!-- <span *ngIf="f['zip'].errors && f['zip'].errors['pattern']">Invalid Zip</span> -->
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-col">
          <p-select formControlName="country" [options]="countryList" optionLabel="country" optionValue="countryId"
            placeholder="Select Country" styleClass="w-full" class="custom-state-select custom-inspection-select"
            [filter]="true" [ngClass]="{'input-invalid': (f['country'].touched || submitted) && f['country'].invalid}">
          </p-select>
          <!-- <div class="error" *ngIf="(f['country'].touched || submitted) && f['country'].invalid">Required</div> -->
        </div>
      </div>
    </div>

    <div class="form-col">
      <div class="form-group-container">
        <label>
          Certificates and Qualifications
        </label>
        <h4 class="certificate-label">Select all required certificates and qualifications below</h4>
        <p-multiSelect [options]="certificateList" formControlName="certificates" [filter]="false"
          placeholder="Select Certificates" [showToggleAll]="false" [panelStyle]="{minWidth:'12rem'}"
          styleClass="w-full" [maxSelectedLabels]="2">
        </p-multiSelect>
        <!-- <div class="error" *ngIf="(f['certificates'].touched || submitted) && f['certificates'].invalid">Required</div> -->
      </div>
      <div class="form-group-container">
        <label [ngClass]="{'label-invalid': (f['industry'].touched || submitted) && f['industry'].invalid}">
          Industry
        </label>
        <h4 class="certificate-label">Choose the industry related to your RFQ<sup class="required-star">*</sup></h4>
        <p-select [options]="industryList" formControlName="industry" placeholder="Select Industry" styleClass="w-full"
          [ngClass]="{'input-invalid': (f['industry'].touched || submitted) && f['industry'].invalid}">
        </p-select>
        <!-- <div class="error" *ngIf="(f['industry'].touched || submitted) && f['industry'].invalid">Required</div> -->
      </div>
      <div class="form-group-container">
        <label>
          Inspection
        </label>
        <h4 class="certificate-label">Choose required inspections for your RFQ</h4>
        <p-multiSelect [options]="inspectionList" formControlName="inspection" [filter]="false"
          placeholder="Select Inspection" [showToggleAll]="false" [panelStyle]="{minWidth:'12rem'}"
          styleClass="w-full custom-inspection-select" [maxSelectedLabels]="2">
         
        </p-multiSelect>
        <!-- <div class="error" *ngIf="(f['inspection'].touched || submitted) && f['inspection'].invalid">Required</div> -->
      </div>
      <div class="form-group-container">
        <label [ngClass]="{'label-invalid': (f['paymentTerms'].touched || submitted) && f['paymentTerms'].invalid}">
          Payment Terms
        </label>
        <h4 class="certificate-label">What are your preferred payment terms?<sup class="required-star">*</sup></h4>
        <p-select [options]="paymentTermsList" formControlName="paymentTerms" placeholder="Select Payment Terms"
          styleClass="w-full"
          [ngClass]="{'input-invalid': (f['paymentTerms'].touched || submitted) && f['paymentTerms'].invalid}">
        </p-select>
        <!-- <div class="error" *ngIf="(f['paymentTerms'].touched || submitted) && f['paymentTerms'].invalid">Required</div> -->
      </div>
    </div>
  </div>
  <div class="btn-container">
    <button type="submit" class="submit-btn">Add Parts to Your RFQ</button>
  </div>
</form>
<!-- [(ngModel)]="localData.rfqName"  -->